import React from 'react';
import PropTypes from 'prop-types';
import { I18n as I } from 'react-redux-i18n';

import BidComponent from '../bids/BidComponent';
import PlacementComponent from '../bids/PlacementComponent';

import { Countdown, AuctionStatuses, PartyTypes, parseDate } from 'vdlib';
import { Row, Col, Button } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

class AuctionNotification extends React.Component {
  constructor(props) {
    super(props);

    // in case auctions expires while in here
    this.state = { auctionFinished: false };
  }

  render() {
    const { isMerchant, offerInfo } = this.props;

    if (
      this.props.status == AuctionStatuses.Active &&
      !this.state.auctionFinished
    ) {
      return (
        <Row gutter={[16, 0]}>
          <Col
            xs={24}
            xl={isMerchant && !this.props.auction.OnlineMode ? 14 : 24}
          >
            <div className="note note-info">
              <Countdown
                endDate={parseDate(this.props.auction.EndDate)}
                onFinish={() => {
                  this.setState({ auctionFinished: true });
                  this.props.onAuctionFinish();
                }}
              />
            </div>
          </Col>
          {isMerchant && !this.props.auction.OnlineMode ? (
            <Col xs={24} xl={10}>
              <Row align="middle">
                <Col xs={24}>
                  <BidComponent
                    auction={this.props.auction}
                    onSubmit={this.props.onBidSubmit}
                    userId={this.props.userId}
                    merchantFees={this.props.merchantFees}
                    membershipID={this.props.membershipID}
                  />
                </Col>
              </Row>
            </Col>
          ) : null}
        </Row>
      );
    }

    let isFinished =
      this.props.status == AuctionStatuses.ForSelection ||
      this.props.status == AuctionStatuses.ForAcceptance ||
      this.props.status == AuctionStatuses.Finished ||
      this.state.auctionFinished;

    return isMerchant ? (
      isFinished ? (
        this.props.auction.OnlineMode ? (
          <Row gutter={[16, 0]}>
            <Col xs={24}>
              <div className={`note note-danger`}>
                <Row>
                  <InfoCircleOutlined
                    style={{ marginRight: 10, fontSize: 16 }}
                  />
                  <p>
                    Δώστε τις προσφορές σας! Τα τελευταία 2 λεπτά κάθε φορά που
                    θα δίνετε νέα προσφορά θα ανανεώνεται ο χρόνος για άλλα 30
                    δευτερόλεπτα!
                  </p>
                </Row>
              </div>
            </Col>
          </Row>
        ) : this.props.status == AuctionStatuses.ForSelection ? (
          <Row gutter={[16, 0]}>
            <Col xs={24} xl={14}>
              <div className="note note-danger">
                <p>{I.t('WAITING_SELECTION_FROM_INSURANCE')}</p>
              </div>
            </Col>
            <Col xs={24} xl={9}>
              <PlacementComponent
                offerInfo={offerInfo}
                merchantFees={this.props.merchantFees}
                membershipID={this.props.membershipID}
              />
            </Col>
          </Row>
        ) : this.props.status == AuctionStatuses.ForAcceptance ? (
          <Row gutter={[16, 0]}>
            <Col xs={24} xl={14}>
              <div className="note note-danger">
                <p>{I.t('OFFER_ACCEPTED_RESPONE')}</p>
              </div>
            </Col>
            <Col xs={24} xl={9}>
              <PlacementComponent
                offerInfo={offerInfo}
                merchantFees={this.props.merchantFees}
                membershipID={this.props.membershipID}
              />
            </Col>
          </Row>
        ) : this.props.status == AuctionStatuses.Finished ? (
          <div className="note note-danger">
            <p>{I.t('COMPLETED')}</p>
          </div>
        ) : (
          <Row gutter={[16, 0]}>
            <Col xs={24} xl={14}>
              <div className={`note note-danger`}>
                <p>{I.t('AUCTION_ENDED')}</p>
              </div>
            </Col>
            <Col xs={24} xl={10}>
              <PlacementComponent
                offerInfo={offerInfo}
                merchantFees={this.props.merchantFees}
                membershipID={this.props.membershipID}
              />
            </Col>
          </Row>
        )
      ) : (
        <div className="note note-danger">
          <p>{I.t('AUCTION_CANCELED')}</p>
          <span className="bold">{this.props.cancellationReason}</span>
        </div>
      )
    ) : this.props.status == AuctionStatuses.ForAcceptance ? (
      <Row gutter={[16, 0]}>
        <Col xs={24}>
          <div className="note note-danger">
            <p>{I.t('WAITING_FOR_ACCEPT_FROM_MERCHANT')}</p>
          </div>
        </Col>
      </Row>
    ) : isFinished ? (
      this.props.status == AuctionStatuses.Finished ? (
        <div className="note note-danger">
          <p>{I.t('COMPLETED')}</p>
        </div>
      ) : (
        <div className={`note note-success`}>
          <p>
            {I.t('AUCTION_ENDED')}
            {(this.props.partyTypeDescription == PartyTypes.Insurance ||
              this.props.partyTypeDescription == PartyTypes.Admin_Insurance ||
              this.props.partyTypeDescription == PartyTypes.Operator) &&
            this.props.hasBids !== true
              ? I.t('NO_OFFERS_CONTINUE')
              : ''}
          </p>
          {this.props.partyTypeDescription == PartyTypes.Insurance &&
          this.props.hasBids === true ? (
            <p>{I.t('OFFER_CHOSE_ONE_FROM_THEM')}</p>
          ) : (
            false
          )}
        </div>
      )
    ) : this.props.status == AuctionStatuses.Pending ? (
      <div className="note">
        <p>{I.t('AUCTION_NOT_STARTED_YET')}</p>
      </div>
    ) : (
      <div className="note note-danger">
        <p>{I.t('AUCTION_CANCELED')}</p>
        <span className="bold">{this.props.cancellationReason}</span>
      </div>
    );
  }
}

AuctionNotification.propTypes = {
  countdown: PropTypes.object,
  hasBids: PropTypes.bool.isRequired,
  onAuctionFinish: PropTypes.func.isRequired,
  partyTypeDescription: PropTypes.string,
  status: PropTypes.string.isRequired,
  startDate: PropTypes.object,
};

export default AuctionNotification;
